import { useCallMutation } from '@/common/api/client'
import { AdminApiPath, RetrainResponse, RetrainVars } from '@/common/api/params/admin'

export const useRetrainApi = (options?: {
  onSuccess?: (response: RetrainResponse) => void
  onError?: (error: Response) => void
}) => {
  return useCallMutation<RetrainResponse, RetrainVars>(AdminApiPath.RETRAIN, options)
}
